import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Modal, Select } from 'antd';
import debounce from 'lodash.debounce';
import { useUpdateStatus } from 'api/orders/use-update-status.ts';
import type { TOrderStatus } from 'api/swagger';
import { OrderStatus } from 'types/order.ts';

export interface IOrderStatusEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentStatus?: TOrderStatus;
  orderId: number;
}

export interface IStatusFormFields {
  status: OrderStatus;
}

export const OrderStatusEditModal: React.FC<IOrderStatusEditModalProps> = (props) => {
  const { isOpen, onClose, currentStatus, orderId } = props;
  const { t } = useTranslation('order');

  const { mutateAsync: updateStatus, isLoading } = useUpdateStatus(orderId);

  const [form] = Form.useForm();
  const handleOk = debounce(() => form.submit(), 200);

  const onFinish = async (values: IStatusFormFields) => {
    await updateStatus(values);
    onClose();
    form.resetFields();
  };

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal title={t('edit_status')} open={isOpen} confirmLoading={isLoading} onCancel={handleClose} onOk={handleOk}>
      <Form form={form} name='order_status' layout='vertical' onFinish={onFinish}>
        <Form.Item name='status' rules={[{ required: true, enum: Object.values(OrderStatus) }]}>
          <Select placeholder={t('status')} size={'large'}>
            {currentStatus === 'failed' || currentStatus === 'cancelled' ? (
              <Select.Option value={OrderStatus.accepted}>{t('status_rewert')}</Select.Option>
            ) : (
              <>
                <Select.Option value={OrderStatus.cancelled}>{t('status_cancelled')}</Select.Option>
                <Select.Option value={OrderStatus.failed}>{t('status_failed')}</Select.Option>
              </>
            )}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
